import React, {FC} from 'react';
import {TEXT} from './ReferralInfoBanner.definition';

import {Banner, View, ViewProperties} from '@lookiero/aurora';
import {useLocation, useNavigate} from 'react-router-native';
import {useIntl} from 'react-intl';
import {Path} from '../../../../modules/routing/routes.definition';
import {useRafImagePath} from '../hooks/useRafImagePaths';

export const ReferralInfoBanner: FC<ViewProperties> = ({...rest}) => {
  const {pathname} = useLocation();
  const {formatMessage} = useIntl();
  const navigate = useNavigate();
  const bannerInfoImage = useRafImagePath('banner-info');

  return (
    <View {...rest}>
      <Banner
        title={formatMessage(TEXT.BANNER)}
        image={bannerInfoImage}
        primaryButton={{
          text: formatMessage(TEXT.BANNER_CTA),
          onPress: () => {
            if (pathname !== Path.REFERRALS) navigate(Path.REFERRALS);
          },
        }}
      />
    </View>
  );
};
